import  { FETCH_USERS ,UPDATE_USERS, UPDATE_USERS_ERROR,FETCH_COACHES } from  '../actions/ActionTypes';
import api from '../api'
import { MESSAGE } from "../helpers/constants"
import { toast } from 'react-toastify';

export function fetchUsers() {
    return function (dispatch) {
        api.get('users').then(async (response) => {
            if (response.status === "success") {
                // let approvedUsers = response.payload.filter(x=>x.status != "PENDING");
                // let pendingUsers = response.payload.filter(x=>x.status === "PENDING");
                await dispatch({
                    type: FETCH_USERS,
                    users: response.payload
                });
            }
        });
    }
}



export function fetchCoaches() {
    return function (dispatch) {
        api.get('all-coaches').then(async (response) => {
            if (response.status === "success") {
                await dispatch({
                    type: FETCH_COACHES,
                    coaches: response.payload
                });
            }
        });
    }
}

export function updateUser(router, data,id) {
	return function (dispatch) {   

        let formData = new FormData();

            if(data.user_image !== null){
                formData.append('user_image', data.user_image);
            }
            
            formData.append("first_name", data.first_name);
            formData.append('last_name', data.last_name);
            formData.append('email', data.email);
            formData.append('phone', data.phone);
            formData.append('location', data.location);
            formData.append('city', data.city);
            formData.append('state', data.state);
            formData.append('country', data.country);
            formData.append('zipcode', data.zipcode);

	api.normalPut("users/"+id, formData).then(async (response) => {
      
        if (response.status === "success") {
             toast.success(MESSAGE.user_upadte, {
                position: toast.POSITION.BOTTOM_RIGHT
            })
			await dispatch({
						type: UPDATE_USERS,
						data: response.payload
					});
		} else {
            toast.error(response.message, {
				position: toast.POSITION.BOTTOM_RIGHT   
			});
			await dispatch({
				type: UPDATE_USERS_ERROR,
				data: response.message
			});
		}
	})
	router.setState({
        open: false,
     }); 
	}
}


export function changePassword(self, state) {
	return function (dispatch) {
		let data = {}
        data.password = state.password;

		api.post("change-password", data).then( (response) => {
            
			if (response.status === "success") {
				toast.success(MESSAGE.password_changed, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                self.setState({
                    ChangePasswordModal: false,

                });
               
				// alert(JSON.stringify(response))
				// await dispatch({
				// 	type: CHANGE_PASSWORD,
				// 	data: response.payload
				// });
			}
		})
	}
}

